<template>
  <div>
    <Modal :config="importProjectModalConfig" @accept="importProject()">
        <template slot="header">
            <span v-if="selectedProject.projektNr !== null && selectedProject.projektNr !== '-' ? selectedProject.projektNr : ''">{{selectedProject.projektNr}} - </span>{{selectedProject.navn}}
        </template>
        <template slot="content">
            <p class="text-center">Dette kan tage noget tid.</p> 
        </template>
    </Modal>

    <Modal :config="removeProjectModalConfig" @accept="removeProject()">
        <template slot="header">
            Slet projekt
        </template>
        <template slot="content">
            <div class="modal-body">
                <p class="text-center">Er du sikker på, at du vil slette projektet?</p>
                <p class="text-center">Dette kan ikke fortrydes.</p>
            </div>
        </template>
    </Modal>

    <Modal :config="projectHandlerModalConfig">
        <template slot="header">
            {{projectHandlerHeader}}
        </template>
    </Modal>

    <Modal :config="projectImportErrorModalConfig">
        <template slot="header">
            Der blev ikke fundet aktiver til projektet
        </template>
    </Modal>

    <!-- project kpi -->
    <!-- <div class="grid-x filterContainer flexbox-center">
        <div v-for="(kpi, index) in KPIList" :key="index">
            <div v-if="kpi.filter === 'onGoing' && kpi.selected">
                <span class="filter-label">Filtre:</span>
                <div class="filters flexbox-center">
                    <span>Igangværende</span>
                    <div class="filtersClose" @click="removeKPIFilter(kpi)">
                        <icon class="small-svg fill-selected-dark-gray" name="cancel"></icon>
                    </div>
                </div>
            </div>
            <div v-if="kpi.filter === 'correction' && kpi.selected">
                 <span class="filter-label">Filtre:</span>
                <div class="filters flexbox-center">
                    <span>Berigtigelse</span>   
                    <div class="filtersClose" @click="removeKPIFilter(kpi)">
                        <icon class="small-svg fill-selected-dark-gray" name="cancel"></icon>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <!-- project counter -->
    <div class="grid-x list-counter">
        <div class="flexbox align-items" v-if="projects.length > 0" style="width: 100%;">
            <div style="margin-right: 7px; flex: 1;">
                {{projects.length}} projekt<span v-if="projects.length !== 1">er</span>
            </div>
            <a @click="exportAsExcel()" class="button button-simplified">
                <icon class="small-svg fill-primary" name="export"></icon>
                Eksportér
            </a>
        </div>
        <div v-else class="large-12 cell no-result">
            <span>Ingen projekter, prøv med et andet:</span>
            <ul>
                <li>søgeord</li>
                <li>filter</li>
            </ul>
        </div>
    </div>
    
    <!-- project sort -->
    <div v-if="projects.length > 0" class="grid-x list-sort">
      <div class="large-2 cell item flexbox no-margin" @click="sort('projektStatusKode')" :class="{selected: currentSort === 'projektStatusKode'}">
          <span>Status</span>
          <div>
              <icon v-if="currentSort === 'projektStatusKode'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'projektStatusKode'}" name="keyboard_arrow_sort"></icon>
          </div>
      </div>
      <div class="large-4 cell item flexbox no-margin" @click="sort('projektNr')" :class="{selected: currentSort === 'projektNr'}">
          <span>Projektnr</span>
          <div>
              <icon v-if="currentSort === 'projektNr'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'projektNr'}" name="keyboard_arrow_sort"></icon>
          </div>
      </div>
      <div class="large-3 cell item flexbox no-margin" @click="sort('navn')" :class="{selected: currentSort === 'navn'}">
          <span>Navn</span>
          <div>
              <icon v-if="currentSort === 'navn'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'navn'}" name="keyboard_arrow_sort"></icon>
          </div>
      </div>
      <div class="large-2 cell item flexbox" @click="sort('projektVaerdi')" :class="{selected: currentSort === 'projektVaerdi'}">
          <span>Værdi</span>
          <div>
              <icon v-if="currentSort === 'projektVaerdi'" class="small-svg fill-selected-dark-gray" :class="{rotated: currentSortDir === 'desc' && currentSort === 'projektVaerdi'}" name="keyboard_arrow_sort"></icon>
          </div>
      </div>
    </div>

    <!-- project list -->
    <transition-group name="list" tag="div">
        <div v-for="(project, index) in sortedProjects" :key="index">
            <div class="grid-x list-row entity-icon-row align-items">
                <div @click="goToProject(project)" class="large-2 cell flexbox-align-items">
                    <div class="entity-icon-test">
                        <icon class="small-svg fill-primary" :name="project.projektStatusKode | translateProjectStatusCode"></icon>
                    </div>
                </div>
                <div @click="goToProject(project)" class="large-4 cell item truncate-fade">
                    <span>{{ project.projektNr }}</span>
                    <span v-if="project.beskrivelse">{{ project.beskrivelse }}</span>
                    <span v-else>Ingen beskrivelse</span>
                </div>
                <div @click="goToProject(project)" class="large-3 cell item truncate-fade flexbox-align-items">
                    <span v-if="project.navn">{{ project.navn }}</span>
                    <span v-else>Intet navn</span>
                </div>
                <div @click="goToProject(project)" class="auto cell item truncate-fade flexbox-align-items">
                    <span v-if="project.projektVaerdi">{{ project.projektVaerdi | convertToLocalStringDK}} kr.</span>
                    <span v-else>Ingen værdi</span>
                </div>
                <div v-if="project.projektStatusKode === 2 || project.projektStatusKode === 3 || project.projektStatusKode === 4" class="large-1 cell item truncate-fade flexbox-align-items">
                    <div @click="openRemoveProject(project)" class="button-list-with-icon cursor">
                        <icon class="medium-svg fill-white" name="delete"></icon>
                    </div>
                </div>
            </div>
        </div>
    </transition-group>

    <paginate :records="projects.length" v-model="sortedProjects" :page-size="perPage" :changePage="changePage" :showPaging="false" :position="'left'" :selectedTab="selectedTab" :activePage="currentPage"></paginate>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from '@/store/api.js'
import Modal from '@/components/modal/modal.vue'
import { ModalConfig } from '@/components/modal/modal.js'
import paginate from '@/components/paginate/paginate.vue'

export default {
    name: 'dashboard-projects-list',
    components: {
        Modal,
        paginate
    },
    props: {
        value: Array,
        selectedTab: String,
        kpi: Array
    },
    data () {
        return {
            projects: this.value,
            KPIList: this.kpi,
            currentSort: 'projektNr',
            currentSortDir: 'asc',
            currentPage: 1,
            data: null,
            perPage: 10,
            selectedProject: {},
            importProjectModalConfig: null,
            removeProjectModalConfig: null,
            projectHandlerModalConfig: null,
            projectImportErrorModalConfig: null,
            projectHandlerHeader: ''
        }
    },
    computed: {
        ...mapGetters({
            selectedRegnskab: 'getSelectedRegnskab'
        }),
        sortedProjects () {
            let sortedArray = this.projects.slice(0).sort((a, b) => {
                let modifier = 1
                if (this.currentSortDir === 'desc') {
                    modifier = -1
                }
                if (a[this.currentSort] < b[this.currentSort] || a[this.currentSort] === null) {
                    return -1 * modifier
                }
                if (a[this.currentSort] > b[this.currentSort] || b[this.currentSort] === null) {
                    return 1 * modifier
                }
                return 0
            })

            let groups = []

            // eslint-disable-next-line
            while (sortedArray && sortedArray.length > 0) {
                groups.push(sortedArray.splice(0, this.perPage))
            }
            return groups[this.currentPage - 1]
        }
    },
    methods: {
        async importProject () {
            try {
                this.projectHandlerHeader = 'Importerer projekt...'
                this.projectHandlerModalConfig.open()
                const response = await axios.post('/Value/Project/ImportProject', {
                    eksternId: this.selectedProject.eksternId,
                    regnskabId: this.selectedProject.regnskabId
                })
                if (response.data) {
                    this.projectHandlerModalConfig.close()
                    this.$router.push({
                        name: 'matchid',
                        params: {
                            id: response.data.id
                        }
                    })
                } else {
                    this.projectHandlerModalConfig.close()
                    this.projectImportErrorModalConfig.open()
                }
            } catch (err) {
                this.projectHandlerHeader = 'Der skete en fejl'
                setTimeout(() => {
                    this.projectHandlerModalConfig.close()
                }, 2000)
                console.log('error import project', err)
            }
        },
        async removeProject () {
            try {
                const response = await axios.post('/Value/Project/DeleteProject', {
                    id: this.selectedProject.id
                })
                if (response) {
                    this.$emit('updateProjectList')
                }
            } catch (err) {
                console.log('error removing project', err)
            }
        },
        openRemoveProject (project) {
            this.selectedProject = project
            this.removeProjectModalConfig.open()
        },
        changePage (page) {
            this.currentPage = page
        },
        sort (s) {
            if (s === this.currentSort) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
            }
            this.currentSort = s
        },
        goToProject (project) {
            if (project.projektStatusKode === 1) {
                this.selectedProject = project
                this.importProjectModalConfig.open()
            } else if (project.projektStatusKode === 2) {
                this.$router.push({
                    name: 'matchid',
                    params: {
                        id: project.id
                    }
                })
            } else {
                this.$router.push({
                    name: 'projectid',
                    params: {
                        id: project.id
                    }
                })
            }
        },
        removeKPIFilter (kpi) {
            this.$emit('removeKPIFilter', kpi)
        },
        exportAsExcel () {
            this.$emit('export')
        }
    },
    watch: {
        value (projects) {
            this.projects = projects
        },
        kpi (KPIList) {
            this.KPIList = KPIList
        }
    },
    created () {
        this.importProjectModalConfig = new ModalConfig({
            reject: 'Annuller',
            accept: 'Importer projekt'
        })
        this.removeProjectModalConfig = new ModalConfig({
            reject: 'Annuller',
            accept: 'Slet projekt'
        })
        this.projectHandlerModalConfig = new ModalConfig({})
        this.projectImportErrorModalConfig = new ModalConfig({
            accept: 'Luk vindue'
        })
    }
}
</script>

<style lang="scss" scoped>
.modal-body p {
    margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/dashboard/dashboard-projects-list.vue